// resources/js/lib/bugsnag-breadcrumbs.js
import bugsnag from './bugsnag'

// Helper function to leave breadcrumbs for user actions
export const leaveBreadcrumb = (message, metadata = {}, type = 'user') => {
    bugsnag.leaveBreadcrumb(message, metadata, type)
}

// Navigation breadcrumbs
export const logNavigation = (from, to) => {
    leaveBreadcrumb(
        'Navigation',
        {
            from: from,
            to: to,
            timestamp: new Date().toISOString(),
        },
        'navigation',
    )
}

// API call breadcrumbs
export const logApiCall = (method, url, status, responseTime) => {
    leaveBreadcrumb(
        'API Call',
        {
            method: method,
            url: url,
            status: status,
            responseTime: responseTime,
            timestamp: new Date().toISOString(),
        },
        'request',
    )
}

// User action breadcrumbs
export const logUserAction = (action, details = {}) => {
    leaveBreadcrumb(
        'User Action',
        {
            action: action,
            ...details,
            timestamp: new Date().toISOString(),
        },
        'user',
    )
}

// Campaign/advertising action breadcrumbs
export const logAdvertisingAction = (action, entityType, entityId, details = {}) => {
    leaveBreadcrumb(
        'Advertising Action',
        {
            action: action,
            entityType: entityType,
            entityId: entityId,
            ...details,
            timestamp: new Date().toISOString(),
        },
        'state',
    )
}

// Error breadcrumbs for caught exceptions
export const logCaughtError = (error, context = {}) => {
    leaveBreadcrumb(
        'Caught Error',
        {
            error: error.message,
            stack: error.stack,
            ...context,
            timestamp: new Date().toISOString(),
        },
        'error',
    )
}

// Manual error reporting functions
export const reportError = (error, context = {}) => {
    bugsnag.notify(error, (event) => {
        event.addMetadata('context', context)
        return true
    })
}

export const reportHandledError = (error, severity = 'warning', context = {}) => {
    bugsnag.notify(error, (event) => {
        event.severity = severity
        event.addMetadata('context', context)
        event.addMetadata('handled', { manually: true })
        return true
    })
}
